import React from 'react'
import PieGraph, { PieGraphProps } from './PieGraph'

export default function SemiCircleGraph({ sideLength = 250, ...props }: PieGraphProps) {
  const height = sideLength / 2 + 20
  return (
    <PieGraph {...props} sideLength={sideLength} startAngle={0} endAngle={180} height={height} />
  )
}
